<template>
  <div>
    <!-- DELETE DIALOG -->
    <v-dialog v-model="delDialog" max-width="300px">
      <v-card :loading="delDialogLoading">
        <v-card-title>Delete?</v-card-title>
        <v-card-text>
          Are you sure you want to delete {{ this.who.name }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="delSponsor()">Yes</v-btn>
          <v-btn text color="error" @click="delDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app-bar app fade-img-on-scroll shrink-on-scroll dark color="#225590">
      <v-layout>
        <v-flex style="font-size:1em">DoCSoc Sponsors Portal: Admin Panel</v-flex>
        <SignOut></SignOut>
      </v-layout>
    </v-app-bar>
    <v-layout justify-center>
      <v-flex md6 xs12>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title>
                Create Sponsor
              </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card :loading="uploading">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Name*"
                            :rules="[v => !!v || 'Name is required']"
                            v-model="form.name"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            label="Email*"
                            :rules="[v => !!v || 'Email is required']"
                            v-model="form.email"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            label="Password*"
                            :rules="[v => !!v || 'Password is required']"
                            v-model="form.password"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            label="Rank*"
                            :items="['Gold', 'Silver', 'Bronze']"
                            required
                            :rules="[v => !!v || 'Rank is required']"
                            v-model="form.rank"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-switch
                            v-model="form.bespoke"
                            label="Bespoke*"
                            required
                          ></v-switch>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input
                            label="Logo*"
                            :rules="[v => !!v || '1 Logo is required']"
                            required
                            v-model="form.file"
                          >
                          </v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="create"
                      >Create</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>

    <v-container fluid v-for="row in rows" :key="row.rank">
      <v-divider></v-divider>

      <h1>{{ row.rank }} Sponsors</h1>
      <v-data-iterator
        :items="row.sponsors"
        :items-per-page.sync="itemsPerPage"
        :footer-props="{ itemsPerPageOptions }"
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="sponsor in row.sponsors"
              :key="sponsor['.uid']"
              cols="12"
              sm="4"
            >
              <v-card>
                <v-card-title class="subheading font-weight-bold">
                  {{ sponsor.name }}
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="
                      who = sponsor;
                      delDialog = true;
                    "
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-list>
                  <v-list-item class="pa-0">
                    <v-list-item-content>
                      <small>Name</small>
                    </v-list-item-content>

                    <v-list-item-content>
                      <small>Applications through portal</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small>#<br />Applied</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small>#<br />Rejected</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small>#<br />Next step</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small>Open</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small>Deleted</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small>Delete</small>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>

                  <v-list-item
                    class="pa-0"
                    v-for="opportunity in sponsor.opportunities"
                    :key="opportunity['.uid']"
                  >
                    <v-list-item-content>
                      <small>{{ opportunity.name }}</small>
                    </v-list-item-content>

                    <v-list-item-content>
                      <v-icon v-if="opportunity.applyOnPortal">check</v-icon>
                      <v-icon v-else>close</v-icon>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small v-if="!opportunity.applyOnPortal">-</small>
                      <small v-else>{{
                        opportunity.applications.length
                      }}</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small v-if="!opportunity.applyOnPortal">-</small>
                      <small v-else>{{
                        opportunity.applications.filter(a => a.rejected).length
                      }}</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small v-if="!opportunity.applyOnPortal">-</small>
                      <small v-else>{{
                        opportunity.applications.filter(a => a.nextStep).length
                      }}</small>
                    </v-list-item-content>
                    <v-list-item-content>
                      <small v-if="!opportunity.applyOnPortal">-</small>
                      <v-icon v-else-if="opportunity.open">check</v-icon>
                      <v-icon v-else>close</v-icon>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-icon v-if="opportunity.deleted">check</v-icon>
                      <v-icon v-else>close</v-icon>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-btn
                        @click="del(opportunity)"
                        v-if="opportunity.deleted"
                        text
                        icon
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import { db, storage, auth } from "../plugins/firebase";
import SignOut from "../components/SignOut";

export default {
  fiery: true,
  components: { SignOut },
  data() {
    return {
      uploading: false,
      delDialog: false,
      delDialogLoading: false,
      who: "",
      form: {
        name: "",
        email: "",
        password: "",
        bespoke: false,
        rank: "",
        file: []
      },
      valid: true,
      itemsPerPageOptions: [3, 6, 9],
      itemsPerPage: 3,
      rows: [
        {
          rank: "Gold",
          sponsors: this.$fiery(db.collection("Sponsors"), {
            query: sponsors => sponsors.where("rank", "==", "Gold"),
            sub: {
              opportunities: {
                sub: {
                  applications: {}
                }
              }
            }
          }),
          icon: require("../assets/images/icons/gold.png")
        },
        {
          rank: "Silver",
          sponsors: this.$fiery(db.collection("Sponsors"), {
            query: sponsors => sponsors.where("rank", "==", "Silver"),
            sub: {
              opportunities: {
                sub: {
                  applications: {}
                }
              }
            }
          }),
          icon: require("../assets/images/icons/silver.png")
        },
        {
          rank: "Bronze",
          sponsors: this.$fiery(db.collection("Sponsors"), {
            query: sponsors => sponsors.where("rank", "==", "Bronze"),
            sub: {
              opportunities: {
                sub: {
                  applications: {}
                }
              }
            }
          })
        }
      ]
    };
  },
  methods: {
    delSponsor: function() {
      var uid = this.who[".uid"].split("/").slice(-1)[0];
      this.delDialogLoading = true;
      Promise.all(
        this.who.opportunities.map(opportunity =>
          Promise.all(
            opportunity.applications.map(application =>
              Promise.all(
                application.files.map(file => {
                  storage
                    .child("CVs/" + application[".uid"] + "/" + file.name)
                    .delete();
                  console.log(
                    "removing: " +
                      "CVs/" +
                      application[".uid"] +
                      "/" +
                      file.name
                  );
                })
              )
            )
          )
        )
      ).then(() => {
        storage.child("sponsors/" + uid + "-" + this.who.name).delete();
        this.delDialogLoading = false;
        this.delDialog = false;
        this.$fiery.remove(this.who);
        this.who = "";
      });
    },
    del: function(opportunity) {
      if (opportunity.applications.length > 0) {
        // TODO
      } else {
        this.$fiery.remove(opportunity);
      }
    },
    create: function() {
      if (this.$refs.form.validate()) {
        this.uploading = true;
        auth
          .createUserWithEmailAndPassword(this.form.email, this.form.password)
          .then(data => {
            let sponsorInit = {
              applyLink: "",
              enableOpportunities: true,
              logo: "",
              name: this.form.name,
              rank: this.form.rank,
              bespoke: this.form.bespoke ? true : false,
              showName: true,
              text: ""
            };
            let path = "sponsors/" + data.user.uid + "-" + this.form.name;
            storage
              .child(path)
              .put(this.form.file)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadURL => {
                  sponsorInit.logo = downloadURL;
                  db.collection("Sponsors")
                    .doc(data.user.uid)
                    .set(sponsorInit)
                    .then(() => {
                      this.uploading = false;
                      this.$refs.form.reset();
                    });
                });
              });
          })
          .catch(() => {
            this.uploading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.v-list-item__content {
  text-align: center;
}
</style>
